export default "__VITE_ASSET__DIEk6EX9__"